import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment";
import { Utils } from "../../utils";
import { RNSAPI } from "../../api";
import { Postbox, PostboxPaging } from '../postbox/postbox';
import './dialog';
import './message';
import { MainViewModel } from "../../main";
export class editDeadlineDialogViewModel {
    modalMode = ko.observable(0);
    deadlineToBeModified = ko.observable(null);
    showLoadingError = ko.observable(false);
    fKAId = ko.observable('');
    fkAName = ko.observable('');
    savedSuccessfull = ko.observable(false);
    showError = ko.observable(false);
    showSuccess = ko.observable(false);
    showLoader = ko.observable(false);
    verificationType = ko.observable(0);
    verificationDate = ko.observable("YYYY-MM-DD");
    notifyVerifyDeadline = ko.observable(false);
    FVANote = ko.observable("");
    FVADate = ko.observable("YYYY-MM-DD");
    DocumentDate = ko.observable("YYYY-MM-DD");
    FVAError = ko.observable(false);
    FVADocumentError = ko.observable(false);
    FVABeforeDocumentError = ko.observable(false);
    FVAGrantedDate = ko.observable("YYYY-MM-DD");
    FVAPredeadlineDate = ko.observable("YYYY-MM-DD");
    FVAGrantedNote = ko.observable("");
    FVARejectedReason = ko.observable("");
    deactivateCalculation = ko.observable(false);
    movedFVAText = ko.observable("");
    movedPreFVAText = ko.observable("");
    extendDeadlineDate = ko.observable();
    extendPreDeadlineDate = ko.observable();
    extendDeadlineNote = ko.observable();
    extendedPreDeadlines = ko.observableArray([]);
    PreDeadlinesLength = ko.observable(0);
    extendDeadlineClerk = ko.observable();
    pastFristApproved = ko.observable(false);
    allDeadlineExtensionReasons = ko.observableArray([]);
    allExtendsionReasonsLength = ko.observable(0);
    rejectionReason = ko.observable('');
    showHistory = ko.observable(false);
    showRejection = ko.observable(false);
    showSetFVA = ko.observable(false);
    optionEntries = ko.observableArray(["Ablehnung durch Gericht vom " + moment().format("DD.MM.YYYY")]);
    showFVARejected = ko.observable(false);
    showFVAVerification = ko.observable(false);
    showFVAGrandation = ko.observable(false);
    completionReason = ko.observable<string>("");
    newSB = ko.observable("");
    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    }
    ;
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection = ko.observable();
    isAfterFrist = ko.observable(false);
    viewWithoutModal = ko.observable(false);
    isStack = ko.observable(false);
    mailId = ko.observable(null);
    attachmentId = ko.observable(0);
    handleResponses(response, deadlineObj, isSetFVA: boolean, isRejection: boolean = false, stepTypeId = null) {
        let result = response as any;
        this.savedSuccessfull(true);
        this.showLoader(false);
        if (deadlineObj.ExportToOutlook) {
            if (result.OutlookExport === "SUCCESS") {
                this.showError(false);
                this.showSuccess(true);
            }
            else if (result.OutlookExport === "FAILURE") {
                this.showSuccess(false);
                this.showError(true);
            }
            else {
                this.showError(false);
                this.showSuccess(false);
            }
        }
        setTimeout(() => {
            Postbox.publisher().publish("", "updateTFW");
            if (ko.toJS(this.showError) === false) {
                this.savedSuccessfull(false);
                this.showLoader(false);
                this.showError(false);
                this.showSuccess(false);
                if (deadlineObj.ExportToOutlook && isSetFVA)
                    (<HTMLButtonElement>document.getElementById("notifyClerk_FVA")).disabled = false;
                if (isRejection && stepTypeId !== 3) {
                    this.modalMode(2);
                    this.mapDeadline(deadlineObj.Id);
                    if (ko.toJS(this.mailId) !== null)
                        PostboxPaging.publisher().publish("", "LoadLinkedEntrys");
                }
                else {
                    if (!this.viewWithoutModal())
                        $('#extendDeadlineModal').modal('hide');
                    if (ko.toJS(this.mailId) !== null)
                        PostboxPaging.publisher().publish("", "GetEntriesInStackCreation");
                }
            }
        }, 2000);
    }
    async extendDeadline() {
        let deadlineObj = ko.toJS(this.deadlineToBeModified);
        let now = Number(moment(moment.now()).format("YYYYMMDD"));
        let deadlineBeforeToday = Number(moment(moment.now()).format("YYYYMMDD")) > Number(moment(ko.toJS(this.extendDeadlineDate())).format("YYYYMMDD"));
        let predeadBeforeToday = now > Number(moment(ko.toJS(this.extendPreDeadlineDate())).format("YYYYMMDD"));
        let preDeadlines = [];
        for (let i = 0; i < this.extendedPreDeadlines().length; i++) {
            let MultiplePreDeadline = moment($("#Extend_" + i).val(), "YYYY-MM-DD").format("YYYY-MM-DD");
            preDeadlines.push(MultiplePreDeadline);
        }
        const anyMultiPreBeforeToday = preDeadlines.some(d => {
            const num = Number(moment(d, "YYYY-MM-DD").format("YYYYMMDD"));
            return now > num;
        });
        if ((deadlineBeforeToday || predeadBeforeToday || anyMultiPreBeforeToday) && ko.toJS(this.pastFristApproved()) === false) {
            $("#DeadlineExtension_Body").removeClass("show");
            $("#DeadlineExtension_Body").addClass("hide");
            $("#approvePastExtensionDeadlineBody").removeClass("hide");
            $("#approvePastExtensionDeadlineBody").addClass("show");
            return;
        }
        else
            this.pastFristApproved(false);
        let res = "";
        try {
            if (ko.toJS(this.allExtendsionReasonsLength) !== 0)
                res = (<HTMLSelectElement>document.getElementById("DeadlineExtensionSelect")).value;
            this.showLoader(true);
            await RNSAPI.extendDeadline(deadlineObj, ko.toJS(this.extendDeadlineDate()), ko.toJS(this.extendPreDeadlineDate()), ko.toJS(this.extendDeadlineNote()), ko.toJS(this.extendDeadlineClerk()), deadlineObj.ExportToOutlook, res, ko.toJS(preDeadlines), ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
                this.handleResponses(response, deadlineObj, false);
            }).catch((error) => {
                alert("Fehler beim Speichern.");
                this.showLoader(false);
            });
        }
        catch (e) {
            this.showLoader(false);
            this.showError(false);
            alert("Fehler beim Speichern der Frist!");
            console.log(e);
        }
    }
    async verifyDate() {
        switch (ko.toJS(this.verificationType)) {
            case 0:
                if (ko.toJS(this.extendDeadlineDate()) !== ko.toJS(this.verificationDate())) {
                    this.notifyVerifyDeadline(true);
                }
                else {
                    this.resetVerificaitonView();
                    this.extendDeadline();
                }
                break;
            case 1:
                if (ko.toJS(this.verificationDate()) !== ko.toJS(this.FVADate()))
                    this.notifyVerifyDeadline(true);
                else {
                    this.resetVerificaitonView();
                    this.createFVA();
                }
                break;
            case 2:
                if (ko.toJS(this.verificationDate()) !== ko.toJS(this.FVAGrantedDate()))
                    this.notifyVerifyDeadline(true);
                else {
                    this.resetVerificaitonView();
                    this.grantFVA();
                }
                break;
            case 3:
                if (ko.toJS(this.FVARejectedReason()) === "")
                    this.notifyVerifyDeadline(true);
                else {
                    this.notifyVerifyDeadline(false);
                    $("#verifyExtensionDeadlineBody").removeClass("show");
                    $("#verifyExtensionDeadlineBody").addClass("hide");
                    this.FVARejected();
                }
                break;
        }
    }
    resetVerificaitonView() {
        $("#DeadlineExtension_Body").removeClass("hide");
        $("#DeadlineExtension_Body").addClass("show");
        $("#verifyExtensionDeadlineBody").removeClass("show");
        $("#verifyExtensionDeadlineBody").addClass("hide");
    }
    async showCheckExtension() {
        this.verificationType(0);
        this.showVerification();
    }
    async checkDeadlineExtension() {
        if (ko.toJS(this.deadlineToBeModified().CurrentFVA) !== '') {
            $("#approveFVAExtensionDeadlineBody").removeClass("hide");
            $("#approveFVAExtensionDeadlineBody").addClass("show");
            $("#DeadlineExtension_Body").removeClass("show");
            $("#DeadlineExtension_Body").addClass("hide");
        }
        else
            this.showCheckExtension();
    }
    async checkFVAEntry() {
        this.FVAError(false);
        this.FVADocumentError(false);
        this.FVABeforeDocumentError(false);
        const fva = this.FVADate();
        const doc = this.DocumentDate();
        const fvaValid = Utils.isValidISODate(fva);
        const docValid = Utils.isValidISODate(doc);
        if (!fvaValid)
            this.FVAError(true);
        if (!docValid)
            this.FVADocumentError(true);
        if (!fvaValid || !docValid)
            return;
        const fvaNum = Number(moment(fva, "YYYY-MM-DD").format("YYYYMMDD"));
        const docNum = Number(moment(doc, "YYYY-MM-DD").format("YYYYMMDD"));
        if (docNum <= fvaNum) {
            this.verificationType(1);
            this.showVerification();
        }
        else {
            this.FVABeforeDocumentError(true);
        }
    }
    async checkFVAGranted() {
        $("#verifyDeadlineDate_inp").closest('.col').removeClass("has-error");
        $("#verifyDeadlinePreDate_inp").closest('.col').removeClass("has-error");
        this.isAfterFrist(false);
        const granted = ko.toJS(this.FVAGrantedDate());
        const pre = ko.toJS(this.FVAPredeadlineDate());
        const isValidStrict = (d: string) => moment(d, "YYYY-MM-DD", true).isValid();
        let invalid = false;
        if (!isValidStrict(granted)) {
            $("#verifyDeadlineDate_inp").closest('.col').addClass("has-error");
            invalid = true;
        }
        if (!isValidStrict(pre)) {
            $("#verifyDeadlinePreDate_inp").closest('.col').addClass("has-error");
            invalid = true;
        }
        if (invalid)
            return;
        const preNum = Number(moment(pre, "YYYY-MM-DD").format("YYYYMMDD"));
        const grantedNum = Number(moment(granted, "YYYY-MM-DD").format("YYYYMMDD"));
        if (preNum > grantedNum) {
            this.isAfterFrist(true);
            return;
        }
        this.verificationType(2);
        this.showVerification();
    }
    async showFVARejection(step) {
        this.FVARejectedReason("");
        this.showFVARejected(true);
    }
    abortFVARejection() {
        this.showFVARejected(false);
    }
    async showVerification() {
        $("#DeadlineExtension_Body").removeClass("show");
        $("#DeadlineExtension_Body").addClass("hide");
        $("#FVA_DeadlineBody").removeClass("show");
        $("#FVA_DeadlineBody").addClass("hide");
        $("#verifyExtensionDeadlineBody").removeClass("hide");
        $("#verifyExtensionDeadlineBody").addClass("show");
        $("#approveFVAExtensionDeadlineBody").removeClass("show");
        $("#approveFVAExtensionDeadlineBody").addClass("hide");
    }
    async cancelFVA() {
        this.showSetFVA(false);
        this.FVAError(false);
        this.FVADocumentError(false);
        this.DocumentDate("YYYY-MM-DD");
        this.FVADate("YYYY-MM-DD");
        this.FVANote("");
    }
    async cancelFVAGranted() {
        this.FVAGrantedDate("YYYY-MM-DD");
        this.showFVAGrandation(false);
    }
    async showFVAOverview() {
        this.FVAError(false);
        this.FVABeforeDocumentError(false);
        this.FVADate("YYYY-MM-DD");
        this.DocumentDate(ko.toJS(moment().format("YYYY-MM-DD")));
        this.showSetFVA(true);
        let user = RNSAPI.getCurrentLoggedInUser();
        if (user.UseVerificationWorkflow === "1" && user.LawFirmId !== "100154" && ko.toJS(this.deadlineToBeModified().ExportToOutlook)) {
            if (document.getElementById("notifyClerk_FVA"))
                (<HTMLButtonElement>document.getElementById("notifyClerk_FVA")).removeAttribute("checked");
        }
    }
    async showFVAGranted() {
        this.deactivateCalculation(true);
        if (this.deadlineToBeModified().CurrentFVADate !== null)
            this.FVAGrantedDate(ko.toJS(moment(this.deadlineToBeModified().CurrentFVADate).format("YYYY-MM-DD")));
        else
            this.FVAGrantedDate("YYYY-MM-DD");
        this.deactivateCalculation(false);
        this.FVAGrantedNote(ko.toJS(this.deadlineToBeModified).Note);
        this.showFVAGrandation(true);
    }
    async createFVA() {
        let deadlineObj = ko.toJS(this.deadlineToBeModified);
        let notify = false;
        if (deadlineObj.ExportToOutlook) {
            notify = (<HTMLInputElement>document.getElementById('notifyClerk_FVA')).checked;
            (<HTMLButtonElement>document.getElementById("notifyClerk_FVA")).disabled = true;
        }
        this.showLoader(true);
        try {
            await RNSAPI.setFVA(deadlineObj, ko.toJS(this.FVADate()), ko.toJS(this.FVANote()), ko.toJS(this.DocumentDate()), notify, ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
                this.handleResponses(response, deadlineObj, true);
            }).catch((error) => {
                if (deadlineObj.ExportToOutlook)
                    (<HTMLButtonElement>document.getElementById("notifyClerk_FVA")).disabled = false;
                alert("Fehler beim Speichern.");
                this.showLoader(false);
            });
        }
        catch (e) {
            if (deadlineObj.ExportToOutlook)
                (<HTMLButtonElement>document.getElementById("notifyClerk_FVA")).disabled = false;
            this.showLoader(false);
            this.showError(false);
            alert("Fehler beim Speichern");
            console.log(e);
        }
    }
    async grantFVA() {
        let deadlineObj = ko.toJS(this.deadlineToBeModified);
        $("#verifyDeadlineDate_inp").closest('.col').removeClass("has-error");
        $("#verifyDeadlinePreDate_inp").closest('.col').removeClass("has-error");
        this.isAfterFrist(false);
        const granted = ko.toJS(this.FVAGrantedDate());
        const pre = ko.toJS(this.FVAPredeadlineDate());
        const isValidStrict = (d: string) => moment(d, "YYYY-MM-DD", true).isValid();
        let invalid = false;
        if (!isValidStrict(granted)) {
            $("#verifyDeadlineDate_inp").closest('.col').addClass("has-error");
            invalid = true;
        }
        if (!isValidStrict(pre)) {
            $("#verifyDeadlinePreDate_inp").closest('.col').addClass("has-error");
            invalid = true;
        }
        if (!invalid) {
            const preNum = Number(moment(pre, "YYYY-MM-DD").format("YYYYMMDD"));
            const grantedNum = Number(moment(granted, "YYYY-MM-DD").format("YYYYMMDD"));
            if (preNum > grantedNum) {
                this.isAfterFrist(true);
                invalid = true;
            }
        }
        if (invalid)
            return;
        this.showLoader(true);
        let preDeadlines = [];
        for (let i = 0; i < this.extendedPreDeadlines().length; i++) {
            let MultiplePreDeadline = moment($("#Extend_" + i).val(), "YYYY-MM-DD").format("YYYY-MM-DD");
            preDeadlines.push(MultiplePreDeadline);
        }
        try {
            await RNSAPI.grantFVA(deadlineObj, ko.toJS(this.FVAGrantedDate()), ko.toJS(this.FVAPredeadlineDate()), ko.toJS(this.FVAGrantedNote()), preDeadlines, ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
                this.handleResponses(response, deadlineObj, false);
            }).catch((error) => {
                alert("Fehler beim Speichern.");
                this.showLoader(false);
            });
        }
        catch (e) {
            this.showLoader(false);
            this.showError(false);
            alert("Fehler beim ..");
            console.log(e);
        }
    }
    async FVARejected() {
        let deadlineObj = ko.toJS(this.deadlineToBeModified);
        this.showLoader(true);
        try {
            await RNSAPI.rejectFVA(deadlineObj, ko.toJS(this.FVARejectedReason), ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
                this.handleResponses(response, deadlineObj, false);
            }).catch((error) => {
                alert("Fehler beim Speichern.");
                this.showLoader(false);
            });
        }
        catch (e) {
            this.showLoader(false);
            this.showError(false);
            alert("Fehler beim ..");
            console.log(e);
        }
    }
    async cancelVerifyFrist() {
        this.verificationDate("YYYY-MM-DD");
        this.notifyVerifyDeadline(false);
        $("#DeadlineExtension_Body").removeClass("hide");
        $("#DeadlineExtension_Body").addClass("show");
        $("#verifyExtensionDeadlineBody").removeClass("show");
        $("#verifyExtensionDeadlineBody").addClass("hide");
    }
    removePreDeadline(index) {
        this.extendedPreDeadlines.splice(index, 1);
        this.PreDeadlinesLength(this.extendedPreDeadlines().length);
    }
    async addPreDeadline() {
        this.extendedPreDeadlines.push(moment().format("YYYY-MM-DD"));
        this.PreDeadlinesLength(this.extendedPreDeadlines().length);
    }
    async getFristDeadlineReasons() {
        let res = (await RNSAPI.getFristDeadlineReasons());
        if (res.Type === "GetFristExtensionReasonsSuccessful") {
            this.allDeadlineExtensionReasons([]);
            this.allDeadlineExtensionReasons(res.Payload.DeadlineExtendReasonTypes.map((deadlineExtenstionRea) => {
                return deadlineExtenstionRea;
            }));
            this.allExtendsionReasonsLength(this.allDeadlineExtensionReasons().length);
        }
    }
    async editPastFrist() {
        this.pastFristApproved(false);
        $("#DeadlineExtension_Body").removeClass("hide");
        $("#DeadlineExtension_Body").addClass("show");
        $("#approvePastExtensionDeadlineBody").removeClass("show");
        $("#approvePastExtensionDeadlineBody").addClass("hide");
    }
    async showRejectStep(step) {
        this.showRejection(true);
        this.rejectionReason("");
    }
    async abortRejectStep() {
        this.showRejection(false);
    }
    async verifyStep(step) {
        this.showLoader(true);
        await RNSAPI.verifyDeadline(step.Id, step.Type, ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
            this.handleResponses(response, this.deadlineToBeModified(), false);
        }).catch((error) => {
            alert("Fehler beim Speichern.");
            this.showLoader(false);
        });
    }
    async rejectStep(step) {
        if (!ko.toJS(this.rejectionReason)) {
            $("#reasonForRejection_inp").addClass("has-error");
            return;
        }
        $("#reasonForRejection_inp").removeClass("has-error");
        this.showLoader(true);
        await RNSAPI.rejectStep(step.Id, step.Type, ko.toJS(this.rejectionReason), ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
            this.handleResponses(response, this.deadlineToBeModified(), false, true, step.Type);
        }).catch((error) => {
            alert("Fehler beim Speichern.");
            this.showLoader(false);
        });
    }
    async mapDeadline(id) {
        this.savedSuccessfull(false);
        this.showLoader(false);
        this.showError(false);
        this.showSuccess(false);
        this.showRejection(false);
        this.showHistory(false);
        this.showSetFVA(false);
        this.FVADocumentError(false);
        this.showFVARejected(false);
        this.FVARejectedReason("");
        this.showLoadingError(false);
        this.showFVAVerification(false);
        this.showFVAGrandation(false);
        this.isAfterFrist(false);
        if (!this.viewWithoutModal())
            $("#extendDeadlineModal").modal('show');
        await RNSAPI.getDeadlineWithData(id).then((response) => {
            let obj = response.Payload;
            let preDeadlines = obj.PreDeadlines;
            if (!preDeadlines || !Array.isArray(preDeadlines))
                preDeadlines = [];
            this.editPastFrist();
            this.extendDeadlineDate(ko.toJS(moment(obj.Deadline).format("YYYY-MM-DD")));
            this.extendPreDeadlineDate(ko.toJS(moment(obj.PreDeadline).format("YYYY-MM-DD")));
            this.FVAPredeadlineDate(ko.toJS(moment(obj.PreDeadline).format("YYYY-MM-DD")));
            for (let i = 0; i < preDeadlines.length; i++) {
                preDeadlines[i] = ko.toJS(moment(preDeadlines[i]).format("YYYY-MM-DD"));
            }
            this.extendDeadlineNote(ko.toJS(obj.Note));
            this.extendedPreDeadlines(preDeadlines);
            this.PreDeadlinesLength(this.extendedPreDeadlines().length);
            this.extendDeadlineClerk(RNSAPI.getCurrentLoggedInUser().ShortHandSymbol);
            this.deadlineToBeModified(obj);
        }).catch((error) => {
            this.showLoadingError(true);
            this.deadlineToBeModified(null);
        });
    }
    showExtendedColumn(step) {
        if (step.HasToBeVerified || step.Type === 2)
            return true;
        return false;
    }
    openHistory() {
        this.showHistory(true);
    }
    async completeDeadline() {
        if (ko.toJS(this.completionReason) === "") {
            $("#compleationReasonContainer").addClass("has-error");
            return;
        }
        else
            $("#compleationReasonContainer").removeClass("has-error");
        if (this.deadlineToBeModified() && ko.toJS(this.deadlineToBeModified().CurrentFVA) !== '') {
            this.showApproveFVACompletion();
            return;
        }
        await this.doCompleteDeadline();
    }
    async doCompleteDeadline() {
        this.deadlineToBeModified().ReasonForCompletion = ko.toJS(this.completionReason);
        this.showLoader(true);
        await RNSAPI.completeDeadline(this.deadlineToBeModified(), ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
            this.handleResponses(response, this.deadlineToBeModified(), false);
        }).catch((error) => {
            alert("Fehler beim Speichern.");
            this.showLoader(false);
        });
    }
    showApproveFVACompletion() {
        $("#DeadlineExtension_Body").removeClass("show");
        $("#DeadlineExtension_Body").addClass("hide");
        $("#approveFVACompletionDeadlineBody").removeClass("hide");
        $("#approveFVACompletionDeadlineBody").addClass("show");
    }
    cancelFVACompletion() {
        $("#approveFVACompletionDeadlineBody").removeClass("show");
        $("#approveFVACompletionDeadlineBody").addClass("hide");
        $("#DeadlineExtension_Body").removeClass("hide");
        $("#DeadlineExtension_Body").addClass("show");
    }
    async approveFVACompletion() {
        $("#approveFVACompletionDeadlineBody").removeClass("show");
        $("#approveFVACompletionDeadlineBody").addClass("hide");
        $("#DeadlineExtension_Body").removeClass("hide");
        $("#DeadlineExtension_Body").addClass("show");
        await this.doCompleteDeadline();
    }
    pickclerk = async () => {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Sachbearbeiter", ["Sachbearbeiter"], ["Sachbearbeiter"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => this.newSB(selectedObject()["Sachbearbeiter_ID"]));
        $('#Delegatemodal').modal('show');
    };
    async delegateDeadline() {
        $(".form-group").each(function () { $(this).removeClass("has-error"); });
        let delegateobj = ko.toJS(this.deadlineToBeModified());
        let keys = ['Id', 'AddressTypeId', 'CaseId', 'Clerk', 'CompletedBy', 'CompletionDate', 'CompletionDate2', 'CreatedBy', 'CreationDate', 'Deadline', 'EditedAt', 'EditedFromId', 'ExportToOutlook', 'IMEX', 'IsDoubleCheck', 'IsPasswordProtected', 'NotaryOrLawyer', 'Note', 'Note1', 'Note2', 'Note3', 'Note4', 'OutlookMessageId', 'PreDeadline', 'PrDeadline2', 'ProcessTime', 'RecordId', 'ReplacedWith', 'ReviewAt', 'Rubrum', 'StartDate', 'TypeDescription', 'TypeId'];
        let obj = {};
        for (let key in keys) {
            obj[keys[key]] = delegateobj[keys[key]];
        }
        try {
            (<HTMLButtonElement>document.getElementById("postDelegation")).disabled = true;
            let result = await RNSAPI.delegateDeadline(ko.toJS(obj), ko.toJS(this.newSB));
            if (result.Type == "DelegationSuccessful") {
                Postbox.publisher().publish("", "updateTFW");
                if (!this.viewWithoutModal())
                    $('#extendDeadlineModal').modal('hide');
            }
            else {
                alert("Fehler beim Speichern.");
                this.showLoader(false);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    constructor(params: any) {
        this.getFristDeadlineReasons();
        params = params || {};
        if (Object.prototype.hasOwnProperty.call(params, 'showWithoutModal'))
            this.viewWithoutModal(ko.toJS(params.showWithoutModal));
        if (Object.prototype.hasOwnProperty.call(params, 'isStack'))
            this.isStack(ko.toJS(params.isStack));
        if (Object.prototype.hasOwnProperty.call(params, 'MailId'))
            this.mailId(ko.toJS(params.MailId));
        if (Object.prototype.hasOwnProperty.call(params, 'AttachmentId'))
            this.attachmentId(ko.toJS(params.AttachmentId));
        if (params.deadlineId)
            this.mapDeadline(ko.toJS(params.deadlineId));
        PostboxPaging.publisher().subscribe((deadlineData) => {
            this.deadlineToBeModified(null);
            this.completionReason("");
            this.modalMode(deadlineData.Mode);
            this.mapDeadline(deadlineData.Deadline.Id);
            if (deadlineData.Mode === 3)
                this.newSB(deadlineData.Deadline.Clerk);
        }, "EditDeadlineModalData");
    }
    dispose() {
        PostboxPaging.publisher().unsubscribe("EditDeadlineModalData");
    }
}
let html = fs.readFileSync(__dirname + "/editDeadlineDialog.html", "utf8");
ko.components.register("edit-deadline-dialog-view", {
    viewModel: editDeadlineDialogViewModel,
    template: html,
});
